/** Shared page surface styling (billing / subscription look). */
export const pagePanel = 'highlight-card rounded-[var(--radius-xl)] overflow-hidden'

export const pagePanelHeader =
  'px-4 py-3 border-b border-primary-100 bg-surface-secondary'

export const pagePanelBody = 'p-6'

export const pageLink = 'text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors'

export const pageTableHead = 'bg-surface-secondary border-b border-primary-100'

export const pageTableRow =
  'border-b border-primary-100 last:border-b-0 hover:bg-surface-card-hover transition-colors'

export const pageInput =
  'w-full pl-9 pr-3 py-2.5 text-sm border border-primary-100 bg-white text-neutral-900 rounded-lg focus:ring-2 focus:ring-primary-500/15 focus:border-primary-300 transition-colors duration-150 hover:border-primary-200 placeholder:text-neutral-400 focus:outline-none'
